import React from 'react';
import AnimatedScore from './AnimatedScore';

export default function SetsWon({ setsWon }) {
  return <div className="sets-won"><AnimatedScore value={setsWon} /></div>;
}
